import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: "clipboard-icon pointer",
    relative: "",
    onClick: _cache[0] || (_cache[0] = $event => ($options.onCopy()))
  }, [
    _createVNode(_component_Icon, {
      style: _normalizeStyle({opacity: $data.copy ? 1 : 0}),
      "stroke-width": "1",
      class: "icon",
      icon: "clipboard-check",
      stroke: "var(--success-600)",
      width: $props.size,
      height: $props.size
    }, null, 8 /* PROPS */, ["style", "width", "height"]),
    _createVNode(_component_Icon, {
      style: _normalizeStyle({opacity: $data.copy ? 0 : 1}),
      hoverable: "",
      "stroke-width": "1",
      class: "icon",
      icon: "clipboard",
      stroke: "var(--gray-700)",
      width: $props.size,
      height: $props.size
    }, null, 8 /* PROPS */, ["style", "width", "height"])
  ]))
}